import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";
import {
  indexRoute,
  problemStatementsRoute,
  problemStatementsRoute25,
  processFlowRoute,
  projectImplementationRoute,
  TeamImplementationRoute,
  venueRoute,
  sbhthemesRoute,
  updatesRoute,
  teamRoute,
  prizesRoute,
  eligibilityRoute,
  contactUsRoute,
  faqRoute,
  rulesRoute,
  resultSeniorRoute,
  resultJuniorRoute,
  sbh2023Route,
  sbh2024Route,
} from "../../Routes";
import Footer from "../Footer/Footer";
import logo from "../../assets/logo-2025.png";
import "./NavBar.style.css";
import { useState } from "react";

const NavBar = () => {
  const [expanded, setExpanded] = useState(false);

  const navHandler = () => {
    setExpanded(false);
  };
  window.onload = () => setExpanded(false);

  return (
    <>
      <Navbar
        collapseOnSelect
        expanded={expanded}
        expand="xl"
        className="px-3 z-top navbar__color"
      >
        <Navbar.Brand href="/">
          <img
            src={logo}
            alt="logo"
            className="brand-logo"
            style={{
              width: "100%",
              maxHeight: "50px",
            }}
          />
        </Navbar.Brand>
        <Navbar.Toggle
          onClick={() => setExpanded(!expanded)}
          aria-controls="responsive-navbar-nav"
          style={{ paddingInline: 0 }}
        />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <NavDropdown title="Discover about SBH" className="nav-item">
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={indexRoute}>
                  About SBH 2025
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={processFlowRoute}>
                  SBH 2025 Process Flow
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={sbhthemesRoute}>
                  SBH 2025 Themes
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={problemStatementsRoute25}>
                  SBH 2025 Problem Statements
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={teamRoute}>
                  SBH 2025 Teams
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={rulesRoute}>
                  SBH 2025 Rules and Regulations
                </Link>
              </div>
            </NavDropdown>

            <Nav.Item>
              <Nav.Link
                className="nav-link"
                as={Link}
                to={TeamImplementationRoute}
                onClick={navHandler}
              >
                Executive Team
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                className="nav-link"
                as={Link}
                to={projectImplementationRoute}
                onClick={navHandler}
              >
                Project Implementation
              </Nav.Link>
            </Nav.Item>

            <NavDropdown title="Guidelines" className="nav-item">
              <div className="dropdown-item">
                <span className="dot"></span>
                <a
                  href="https://drive.google.com/file/d/1uRrKzlVxOvF8Cfx2byg7mpMUsMFaWMuS/view?usp=sharing"
                  onClick={navHandler}
                  target="_blank"
                  rel="noreferrer"
                >
                  SBH Senior 2025
                </a>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <a
                  href="https://drive.google.com/file/d/1DGmOmTAtopqXPd8SsO2oQo5VdGsNmXqB/view?usp=sharing"
                  onClick={navHandler}
                  target="_blank"
                  rel="noreferrer"
                >
                  SBH Junior 2025
                </a>
              </div>
            </NavDropdown>

            <NavDropdown title="Idea Template" className="nav-item">
              <div className="dropdown-item">
                <span className="dot"></span>
                <a
                  href="https://drive.google.com/uc?export=download&id=159Y7bCQMA-5ntdiD6J0wo-gAO6FNXUMy"
                  download="SBH_Junior_Template_2025.pptx"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href =
                      "https://drive.google.com/uc?export=download&id=159Y7bCQMA-5ntdiD6J0wo-gAO6FNXUMy";
                  }}
                >
                  For Schools
                </a>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <a
                  href="https://drive.google.com/uc?export=download&id=18isLkYCkLUTjry_4tjZnMpBoX6v7jbLO"
                  download="SBH_Senior_Template_2025.pptx"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href =
                      "https://drive.google.com/uc?export=download&id=18isLkYCkLUTjry_4tjZnMpBoX6v7jbLO";
                  }}
                >
                  For Colleges
                </a>
              </div>
            </NavDropdown>

            <NavDropdown title="Consent Letter" className="nav-item">
              <div className="dropdown-item">
                <span className="dot"></span>
                <a
                  href="https://docs.google.com/document/d/16aQZxAO6u0C7sQnho4RBWkwqI9235f8Z/export?format=docx"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href =
                      "https://docs.google.com/document/d/16aQZxAO6u0C7sQnho4RBWkwqI9235f8Z/export?format=docx";
                  }}
                  download="SBH_Senior_2025_Consent-letter.docx"
                >
                  SBH Senior 2025
                </a>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <a
                  href="https://docs.google.com/document/d/1YbYk-eSHT0Oj7UczxdhJVdK7xI7R-VdH/export?format=docx"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href =
                      "https://docs.google.com/document/d/1YbYk-eSHT0Oj7UczxdhJVdK7xI7R-VdH/export?format=docx";
                  }}
                  download="SBH_Junior_2025_Consent-letter.docx"
                >
                  SBH Junior 2025
                </a>
              </div>
            </NavDropdown>

            <NavDropdown title="Hackathon Details" className="nav-item">
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={venueRoute}>
                  Venue
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={updatesRoute}>
                  Registration
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={prizesRoute}>
                  Prizes
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={eligibilityRoute}>
                  Eligibility
                </Link>
              </div>
            </NavDropdown>

            <Nav.Item>
              <Nav.Link
                className="nav-link"
                as={Link}
                to={faqRoute}
                onClick={navHandler}
              >
                FAQs
              </Nav.Link>
            </Nav.Item>

            <NavDropdown title="Past Seasons" className="nav-item">
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={sbh2024Route}>
                  SBH 2024
                </Link>
              </div>
              <div className="dropdown-item">
                <span className="dot"></span>
                <Link onClick={navHandler} to={sbh2023Route}>
                  SBH 2023
                </Link>
              </div>
            </NavDropdown>

            <Nav.Item>
              <Nav.Link
                className="nav-link"
                as={Link}
                to={contactUsRoute}
                onClick={navHandler}
              >
                Contact Us
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Outlet />
      <Footer />
    </>
  );
};

export default NavBar;
